/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Title",
  onChange
  
}) {
let formTitleValueData = fromData.useDataValue({ viewPath,
context: 'form',
path: 'title',
})
let formTitleChangeData = fromData.useDataChange({ viewPath,
context: 'form',
path: 'title',
})
  return (<React.Fragment
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 backgroundColor="white"
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 marginTop={0}
 data="form.title"
 onChange={formTitleChangeData}
 value={formTitleValueData}
>
{childProps => (
<React.Fragment>
<TysiaTextareaLabel
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Title"
 required={true}
/>
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 height="auto"
 placeholder="Schedule online appointment"
/>
)}
</TysiaTextareaContent>
</React.Fragment>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}